import config from '@/config'

export default {
	id: 'SIMPLE_PREMIUM_4W_49_4W_49',
	providers: {
		stripe: config('stripe_cheap_and_short'),
		braintree: 'pro_short_cheap',
		paltaMap: {
			USD: 'simple_premium_4w_49_4w_49_usd',
		},
		primer: 'prd_4ErBbKdA0XLB',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 4,
		intro_period_type: 'week',
		next_period_value: 4,
		next_period_type: 'week',
	},
	trial: {
		days: 28,
		priceMap: {
			USD: 49,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 1,
		priceMap: {
			USD: 49,
		},
	},
	options: ($t, product, $tc) => ({
		explicitTermsPeriodText: $t('pages.program.organic.cheap_and_short.plans.30_days.into_period_text'), // 'first month'
		explicitTermsIntervalText: $tc('common.week_plural', 4), // 4 weeks
		billingSubtitlePeriodText: $tc('common.week_plural', 4), // 4 weeks
		footerPeriodText: $tc('common.duration.week.dashed.lowercase', 4), // '4-week'
		footerIntervalText: $tc('common.duration.week.dashed.lowercase', 4), // '4-week'
		updatedTermsPeriodText: $tc('common.duration.week.first', 4), // 'first 4 weeks'
	}),
}
